import { useEventGroup } from "Hooks/Endpoints";
import React, { useState } from "react";
import { Card, Grid, Header, Menu, Segment, Table } from "semantic-ui-react";

import moment from "moment";
import EventSequence from "./EventSequence";
import EventRecordings from "./EventRecordings";
import EventCDRView from "./EventCDRView";
import EventMetaView from "./EventMetaView";
import useCheckRole from "Hooks/APICheckRole";
import { EventGroupListView } from "callable-data-objects";
import EventPBXEventsView from "./EventPBXEventsView";

type EventDetailType = {
  unselect: Function;
  event: EventGroupListView;
};

const EventDetailView = () => {
  const { hasRole, roles } = useCheckRole();
  const { unselect, event }: EventDetailType = useEventGroup();
  const [activeView, setActiveView] = useState("details");

  moment.locale("gb");

  return (
    <div>
      <Menu pointing>
        <Menu.Item
          icon='left arrow'
          onClick={() => unselect()}
          name='Go Back'
        />
        <Menu.Item
          name='details'
          onClick={() => setActiveView("details")}
          active={activeView === "details"}
        ></Menu.Item>
        {event.recordingCount > 0 &&
          hasRole(roles.account.events.recording.roles.view) && (
            <Menu.Item
              name='recordings'
              onClick={() => setActiveView("recordings")}
              active={activeView === "recordings"}
            ></Menu.Item>
          )}
        {hasRole(roles.account.events.debug.roles.view) && (
          <Menu.Item
            name='debug'
            onClick={() => setActiveView("debug")}
            active={activeView === "debug"}
          ></Menu.Item>
        )}
      </Menu>

      {activeView === "details" && (
        <Grid padded stackable>
          <Grid.Column width={4}>
            <Segment color='blue'>
              <Header as='h4'>Event Details</Header>
              <Table size='small' padded={false} singleLine basic stackable>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Event ID</Table.Cell>
                    <Table.Cell>{event.id}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>From</Table.Cell>
                    <Table.Cell>{event.from}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>To</Table.Cell>
                    <Table.Cell>{event.to}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Date</Table.Cell>
                    <Table.Cell>{moment(event.created).format("YYYY-MM-DD HH:mm:ss")}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
          <Grid.Column width={12}>
            {event.cdrCount > 0 &&
              hasRole(roles.account.events.cdr.roles.view) && <EventCDRView />}
            {event.meta && hasRole(roles.account.events.tags.roles.view) && (
              <EventMetaView />
            )}
            {event.pbxEventCount > 0 && <EventPBXEventsView event={event} />}
          </Grid.Column>
        </Grid>
      )}

      {activeView === "debug" && <EventSequence />}

      {activeView === "recordings" && <EventRecordings />}
    </div>
  );
};

export default EventDetailView;
